import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import { mediaQueryUp } from 'components/utils/breakpoint'
import Image from 'components/Common/Image'
import OfferBadgeLabel from 'components/Common/OfferBadgeLabel/OfferBadgeLabel'
import LineMapMarkerIcon from 'components/Luxkit/Icons/line/LineMapMarkerIcon'
import OfferDescription from '../OfferDescription'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import OfferPagePropertyTitle from '../OfferPagePropertyTitle'
import Subtitle from 'components/Luxkit/Typography/Subtitle'
import MarkdownRender from 'components/Luxkit/MarkdownRender'
import OfferPromotions from '../OfferPromotions'
import { OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const PropertyLogo = styled(Image)`
  display: none;

  ${mediaQueryUp.desktop} {
    margin-left: ${rem(16)};
    display: block;
    height: ${rem(75)};
  }
`

const OfferBadgeTagSection = styled.div`
  > * + * {
    margin-left: ${rem(8)};
  }
`

const ContentColumn = styled.div`
  > * + * {
    margin-top: ${rem(16)};
  }
`

interface Props {
  offer: App.Offer;
  property: App.OfferProperty;
  location: string;
  promotions: Array<OfferPackageOptionView>;
}

function UltraLuxPropertyDetails(props: Props) {
  const {
    offer,
    property,
    location,
    promotions,
  } = props

  return (<ContentColumn>
    <Header>
      <VerticalSpacer gap={8}>
        <BodyTextBlock variant="medium" data-testid="offer-location" startIcon={<LineMapMarkerIcon />}>
          {location}
        </BodyTextBlock>
        <OfferPagePropertyTitle propertyName={property.name} />
        <Subtitle variant="subtitle2" as="h2">{offer.name}</Subtitle>
      </VerticalSpacer>
      {property.logoImageId &&
        <PropertyLogo
          dpr={2}
          height={75}
          enhancedFormats={false}
          id={property.logoImageId}
          alt={`${property.name || 'Vendor'} logo`}
        />}
    </Header>
    {(!!offer.badge || offer.bundledWithFlightsOnly) && <OfferBadgeTagSection>
      {offer.badge && <OfferBadgeLabel badge={offer.badge} />}
    </OfferBadgeTagSection>}
    {offer.description && <OfferDescription description={offer.description} />}
    {offer.additionalDescription &&
      <MarkdownRender type="compact" content={offer.additionalDescription} />
    }
    {promotions.length > 0 && <OfferPromotions offer={offer} promotions={promotions} />}
  </ContentColumn>
  )
}

export default UltraLuxPropertyDetails
